import React, { Component, Fragment } from 'react'

import './CronogramaMto.css';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getListaMtos, getListaMtosClienteFiltrado } from '../../../redux/actions/dataactions';
import { postAprobarMto } from '../../../redux/actions/dataasistencialactions';
import moment from 'moment';

import { Link } from 'react-router-dom';
import { FaArrowCircleLeft, FaArrowLeft, FaCheck, FaCheckCircle, FaExclamationTriangle, FaFilePdf, FaSearch } from "react-icons/fa";

import {
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  Typography,
  Stack,
  Grid,
  TextField,
  Button
} from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CheckIcon from '@mui/icons-material/Check';
import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';

import { FaClipboardList } from "react-icons/fa";

export class CronogramaMto extends Component {
  constructor(){
    super();
    this.state={
        errors:{},
        aprobado:{},
        open:false,
        opendelete:false,
        progid:'',
        clienteid:'',
        equipoid:'',
        fechaInicio: '',
        fechaFin: '',
        searchQuery: '',
    };
    
};
    componentDidMount(){
        this.props.getListaMtos(this.props.user.credentials.idprestador);
       }
  
          static getDerivedStateFromProps(props, state) {
        const newState = {};
    
        if (props.UI.errors) {
            newState.errors = props.UI.errors;
        }
    
        if (props.UI.aprobado) {
           newState.aprobado = props.UI.aprobado;
        }
    
        return Object.keys(newState).length > 0 ? newState : null;
    }
        handleOpen=(rawdataprogid,rowdataequipoid)=>{

        this.setState({open:true,progid:rawdataprogid,equipoid:rowdataequipoid,errors:{},aprobado:{}});
    
        };
        handleClose=()=>{
          // this.props.clearErrors();
          if(this.state.aprobado.mensaje||this.state.errors.error){

            this.props.getListaMtosClienteFiltrado(
              this.props.user.credentials.idprestador,
              "01/01/1950",
              "01/01/2035",
              "Todos"
            );
            this.setState({open:false,errors:{},aprobado:{}});
          } else {
            this.setState({open:false,errors:{},aprobado:{}});
          }
        };
          
      // hay que hacer otro aprobar mto 
      handleSubmit=()=>{
        this.props.postAprobarMto(this.state.progid);
      }
  
  handleSearchChange = (event) => {
    this.setState({ searchQuery: event.target.value });
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleResetFiltros = () => {
    this.setState({
      fechaInicio: '',
      fechaFin: '',
      searchQuery: ''
    });

    this.props.getListaMtosClienteFiltrado(
      this.props.user.credentials.idprestador,
      "01/01/1950",
      "01/01/2035",
      "Todos"
    );
  };

  handleFiltrar = () => {
    const { fechaInicio, fechaFin } = this.state;
    this.props.getListaMtosClienteFiltrado(
      this.props.user.credentials.idprestador,
      moment(fechaInicio).format('DD/MM/YYYY'),
      moment(fechaFin).format('DD/MM/YYYY'),
      "Todos"
    );
  };

  filterEquipos = () => {
    const { equiposmto } = this.props.data;
    const { searchQuery } = this.state;
    if (!Array.isArray(equiposmto)) return [];

    const lowerQuery = String(searchQuery || '').toLowerCase();

    const filtered = equiposmto.filter((item) => {
      return [
        item.idinventario,
        item.nombre,
        item.marca,
        item.modelo,
        item.serie,
        item.ubicacion,
        item.estado,
        item.fecha,
        item.actividades
      ].some(field =>
        field != null && String(field).toLowerCase().includes(lowerQuery)
      );
    });

    return filtered.sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
  };

  render() {

    const { equiposmto, loadingmto } = this.props.data;
    const { UI: { loading } } = this.props;
    const { errors } = this.state;
    const filteredRows = this.filterEquipos();
      const columns = [
         {
        field: 'acciones',
        headerName: 'Acciones',
        width: 150,
        sortable: false,
        renderCell: (params) => (
          <Stack direction="row" spacing={1}>
            <Tooltip title="Ver Perfil">
              <IconButton
                size="small"
                component={Link}
                to={`/dashboard/inventarioequiposasistencial/hojadevidaequipo/${params.row.equipoid}/${params.row.clienteid}`}
              >
                <ChevronRightIcon sx={{ color: '#03178C' }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Aprobar Mantenimiento">
            <span>
              <IconButton
                size="small"
                onClick={() => this.handleOpen(params.row.progid, params.row.equipoid)}
                disabled={params.row.aprobado === true || params.row.estado === "Sin realizar"}
              >
                <CheckIcon
                  sx={{
                    color:
                      params.row.estado === "Sin realizar"
                        ? 'gray'
                        : params.row.aprobado
                        ? 'green'
                        : 'red'
                  }}
                />
              </IconButton>
            </span>
          </Tooltip>
             <Tooltip title="Ver Reporte">
                              <IconButton
                                component={Link}
                                to={`/dashboard/perfilcliente/${this.props.user.credentials.idprestador}/cronomtoperfil/reportepdfmto/${params.row.equipoid}/${params.row.progid}/2`}
                                size="small"
                                disabled={params.row.estado === 'Sin realizar'}
                              >
                                <FaFilePdf />
                              </IconButton>
              </Tooltip>
          </Stack>
        )
      },
      {
        field: 'aprobado',
        headerName: 'Aprobado',
        width: 110,
        valueGetter: (params) => (params.row.aprobado ? 'Sí' : 'No')
      },
      { field: 'idinventario', headerName: 'Id', width: 80 },
      { field: 'nombre', headerName: 'Nombre', width: 130 },
      { field: 'marca', headerName: 'Marca', width: 110 },
      { field: 'modelo', headerName: 'Modelo', width: 110 },
      { field: 'serie', headerName: 'Serie', width: 110 },
      { field: 'ubicacion', headerName: 'Ubicación', width: 130 },
      { field: 'estado', headerName: 'Estado', width: 100 },
      { field: 'fecha', headerName: 'Fecha', width: 110 },
      { field: 'hora', headerName: 'Hora', width: 100 },
      { field: 'actividades', headerName: 'Actividades', width: 200 },
      
     
    ];
    
    let mapeoequipos = !loadingmto ? (
      <div>
        <div className='div-container-links-inventario'>
          <Fragment>
            <Link
              className='div-card-link'
              to={{
                pathname: `/dashboard/cronogramamtoasistencial/${this.props.user.credentials.idprestador}`,
                state: { filteredEquipos: filteredRows }
              }}
            >
              <div className="dashing-cardcontent">
                <div className="dashing-cardtext">
                  <p className="dashing-text-card">Ver Cronograma en PDF</p>
                </div>
                <div className="dashing-cardicon-green">
                  <FaFilePdf color="#FFFFFF" className="dashing-icon" />
                </div>
              </div>
            </Link>
          </Fragment>
        </div>

        <Box sx={{ mt: 2, mb: 2 }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                label="Buscar programación"
                variant="outlined"
                value={this.state.searchQuery}
                onChange={this.handleSearchChange}
                InputProps={{
                  startAdornment: (
                    <Box component="span" sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                      <FaSearch color="#d7d7d7" />
                    </Box>
                  )
                }}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} alignItems="center" sx={{ mt: 1 }}>
            <Grid item xs={12} sm={4} md={3}>
              <TextField
                fullWidth
                size="small"
                required
                type="date"
                name="fechaInicio"
                id="fechaInicio"
                label="Desde"
                value={this.state.fechaInicio}
                onChange={this.handleChange}
                helperText={errors.fechaInicio}
                error={Boolean(errors.fechaInicio)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item xs={12} sm={4} md={3}>
              <TextField
                fullWidth
                size="small"
                required
                type="date"
                name="fechaFin"
                id="fechaFin"
                label="Hasta"
                value={this.state.fechaFin}
                onChange={this.handleChange}
                helperText={errors.fechaFin}
                error={Boolean(errors.fechaFin)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item xs={12} sm={4} md={3}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={this.handleFiltrar}
                size="medium"
                sx={{ height: '40px' }}
              >
                Filtrar
              </Button>
            </Grid>

            <Grid item xs={12} sm={4} md={3}>
              <Button
                fullWidth
                variant="outlined"
                color="primary"
                onClick={this.handleResetFiltros}
                size="medium"
                sx={{ height: '40px' }}
              >
                Restablecer
              </Button>
            </Grid>
          </Grid>
        </Box>

        <Box
          sx={{
            height: 500,
            width: '100%',
            mt: 2,
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: 'primary.main',
              color: 'white'
            }
          }}
        >
        <DataGrid
          rows={filteredRows}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[10, 20, 50]}
          getRowId={(row) => row.progid || row.idinventario}
          disableRowSelectionOnClick
        />
        </Box>
      </div>
    ) : (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress size={50} color="primary" />
      </Box>
    )

    return (
        <div className='inventario-container'>

        <div className="titulomarket_section">
        <div className="titulo_market">
        <h1 className="text-clientes">Cronograma Mantenimiento</h1>
        <hr className="clientes_separator"></hr>  

        </div>

        <div className="divmarket_boton">
      
        <Link to={`/dashboard/equiposasistencial`}>
          <Tooltip title="Volver">
            <IconButton size="small">
              <FaArrowCircleLeft color="#03178C" size={20} />
            </IconButton>
          </Tooltip>
        </Link>


        </div>
        </div>
        {mapeoequipos}

        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          fullWidth
          maxWidth="sm"
        >
          {this.state.aprobado.mensaje ? (
            <DialogContent sx={{ textAlign: 'center' }}>
              <FaCheck color="#20b90c" className='icono-aprobado' />
              <Typography className='text-aprobado'>Reporte Aprobado Exitosamente</Typography>
            </DialogContent>
          ) : errors.error ? (
            <DialogContent sx={{ textAlign: 'center' }}>
              <FaExclamationTriangle color="#ffd631" className='icono-aprobado' />
              <Typography className='text-aprobado'>{errors.error}</Typography>
            </DialogContent>
          ) : (
            <DialogTitle>
              <Typography sx={{ fontSize: '20px', fontWeight: 600, color: '#0468BF', textAlign: 'center' }}>
                ¿Estás seguro de Aprobar este Mantenimiento?
              </Typography>
            </DialogTitle>
          )}

          <DialogActions>
            <Tooltip title="Cerrar">
              <IconButton onClick={this.handleClose} size="small">
                <FaArrowLeft color="#D3D7DC" />
              </IconButton>
            </Tooltip>
            {loading ? (
              <CircularProgress size={30} color="primary" className="login-progress" />
            ) : this.state.aprobado.mensaje ? (
              <Tooltip title="Continuar">
                <IconButton onClick={this.handleClose} size="small">
                  <FaCheckCircle color="#20b90c" />
                </IconButton>
              </Tooltip>
            ) : errors.error ? (
              <Link to={`/dashboard/inventarioequiposasistencial/hojadevidaequipo/${this.state.equipoid}`} style={{ color: '#ffd631' }}>
                <Tooltip title="Ir a Perfil">
                  <IconButton size="small">
                    <FaCheckCircle color="#ffd631" />
                  </IconButton>
                </Tooltip>
              </Link>
            ) : (
              <Tooltip title="Aprobar Mantenimiento">
                <IconButton onClick={this.handleSubmit} size="small">
                  <FaCheckCircle color="#03178C" />
                </IconButton>
              </Tooltip>
            )}
          </DialogActions>
        </Dialog>
     
    </div>
    )
  }
}

CronogramaMto.propTypes={
    getListaMtos:PropTypes.func.isRequired,
    getListaMtosClienteFiltrado:PropTypes.func.isRequired,
    data:PropTypes.object.isRequired,
    user:PropTypes.object.isRequired,  
    UI:PropTypes.object.isRequired, 
    postAprobarMto:PropTypes.func.isRequired, 
}
const mapStateToProps=state=>({
    data:state.data,
    user:state.user,
    UI:state.UI
})
export default connect(mapStateToProps,{getListaMtos,getListaMtosClienteFiltrado,postAprobarMto}) (CronogramaMto);
